module.exports = __webpack_public_path__ + "images/feature/0707_doc_code_3-d8e662f64dd43e87d15bd9f8bec61261.jpg";